import React from 'react'
import { TextVariants } from './styled'
import { ConfigurableRenderOptions } from 'lib/modules/catalog'
import { SIZES } from 'resources/constants'

export const Swatches = ({
  selected: currentOptionValue,
  label,
  values,
  attrCode,
  onChange: handleSelectChange
}: ConfigurableRenderOptions) => {
  const current = currentOptionValue
  return (
    <div
      key={attrCode}
    >
      <TextVariants>
        <h3 className='product__steps'>1. Choose your {label}</h3>
        <ul>
          {values.map((option, i) => {
            const { isDisabled, value, label } = option
            const isActive = current && current.value === value
            const isSize = SIZES[label]
            return (
              <li
                key={`${attrCode}-${value}-${i}`}
              >
                <button
                  type='button'
                  title={label}
                  className={isActive ? 'active' : undefined}
                  style={{ width: isSize ? '40px' : 'auto', padding: isSize ? '0' : '0 10px' }}
                  disabled={isDisabled && !isActive}
                  onClick={() => handleSelectChange(option, attrCode)}
                >
                  {SIZES[label] ?? label}
                </button>
              </li>
            )
          })}
        </ul>
      </TextVariants>
    </div>
  )
}
